import { SelectionDate, SelectionAny } from './internal';
export class SelectionDataSource extends SelectionAny {
    getDate() {
        return this.get("DATE" /* Tag.Date */, null, SelectionDate);
    }
    getCopyright() {
        return this.get("COPR" /* Tag.Copyright */);
    }
}
//# sourceMappingURL=SelectionDataSource.js.map